module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "copygrey"
  }, [_vm._v("CONTENTS")]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/03_Abbreviation"
    }
  }, [_vm._v("Abbreviations")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/04_Intoduction"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/05_Chapter_001"
    }
  }, [_c('span', {
    staticClass: "toc-chap_float"
  }, [_vm._v("1")]), _vm._v(" From Sandino to Sandinistas")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-han"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/06_Chapter_002",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-chap_float"
  }, [_vm._v("2")]), _vm._v(" National Guard versus FSLN forces")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-han"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/07_Chapter_003",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-chap_float"
  }, [_vm._v("3")]), _vm._v(" From Guerrilla War to Insurrection")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-han"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08_Chapter_004",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-chap_float"
  }, [_vm._v("4")]), _vm._v(" The September 1978 offensive")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-han"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_Chapter_005",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-chap_float"
  }, [_vm._v("5")]), _vm._v(" From the Spring Offensive to the General Uprising")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Selectedbibliography",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Selected Bibliography")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Notes",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Acknowledgment",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Aouthor",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Author")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9ee5fb14","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/toc.vue
// module id = 63
// module chunks = 0